var map = {
	"./bio_photo.jpg": "293c",
	"./book_cover_full_width.jpg": "b059",
	"./cover_mockup.jpg": "005a",
	"./covers/audiobooks/a_flutter_on_the_wind.jpg": "4084",
	"./covers/audiobooks/the_moon_chasers.jpg": "f2a1",
	"./covers/audiobooks/the_sixth_amulet.jpg": "311f",
	"./covers/flutter_on_the_wind.jpg": "a662",
	"./covers/moon_chasers.jpg": "60f3",
	"./covers/sixth_amulet.jpg": "fa0d",
	"./covers/writing_lessons.jpg": "6116",
	"./history/double-cover.jpg": "a051",
	"./history/kelpie-1.jpg": "8bb2",
	"./history/kelpie-2.jpg": "709e",
	"./history/kelpie-3.jpg": "e2f2",
	"./man.jpg": "4d69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";